/**
 * Format backend slot strings ("HH:00 - HH:00", 24h) into "h AM - h PM" (12h).
 * Keeps the original 24h value as the source of truth everywhere else in the app.
 * Drops the ":00" minutes since all slots in Assenda are whole-hour — yields a
 * much shorter mobile-friendly label (e.g. "7 AM - 8 AM" instead of
 * "7:00 AM - 8:00 AM").
 */
const fmtHour = (h24) => {
  const h = ((h24 % 12) || 12);
  const suffix = h24 < 12 || h24 === 24 ? "AM" : "PM";
  return `${h} ${suffix}`;
};

export const formatSlot = (slotStr) => {
  if (!slotStr || typeof slotStr !== "string") return slotStr || "";
  const parts = slotStr.split("-").map((s) => s.trim());
  if (parts.length !== 2) return slotStr;
  const [s, e] = parts.map((p) => parseInt(p.split(":")[0], 10));
  if (Number.isNaN(s) || Number.isNaN(e)) return slotStr;
  return `${fmtHour(s)} - ${fmtHour(e)}`;
};

/**
 * Compact start-hour-only variant for tight mobile UIs. All Assenda slots
 * are 1-hour blocks, so the start time alone is enough context. Returns
 * "7 AM" instead of "7 AM - 8 AM".
 */
export const formatSlotShort = (slotStr) => {
  if (!slotStr || typeof slotStr !== "string") return slotStr || "";
  const start = slotStr.split("-", 1)[0].trim();
  const h = parseInt(start.split(":")[0], 10);
  if (Number.isNaN(h)) return slotStr;
  return fmtHour(h);
};

export const formatSlots = (slots) => (slots || []).map(formatSlot);
